<template>
    <MainTempComp
        ref="mainTempRef"
        :searchOption="data.searchOption"
        :handleSearch="handleSearch"
    >
        <template #header>
            <span style="padding-left: 10px"></span>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="primary" @click="data.showAddAndEdit = true"
                >添加</el-button>
        </template>
        <template #main>
            <tableComp :tableData="data.tableData"></tableComp>
        </template>
    </MainTempComp>
    <add-edit-user
        ref="AddEditUserRef"
        :currentData="data.currentData"
    ></add-edit-user>
    <addAndEdit
        v-if="data.showAddAndEdit"
        v-model:toggle="data.showAddAndEdit"
    ></addAndEdit>
</template>

<script>
import {onMounted, provide, reactive, ref} from "vue";
import tableComp from "./table.vue";
import {rechargeConfigList} from "@/api/requestApis.js";
import AddEditUser from "./children/add-edit-user.vue";
import addAndEdit from "./addAndEdit.vue";

export default {
    name: "userManage",
    components: {
        addAndEdit,
        tableComp,

        AddEditUser,
    },
    setup() {
        const mainTempRef = ref(null);
        const AddEditUserRef = ref(null);

        const data = reactive({
            showAddAndEdit: false,
            tableData: [],
            currentData: {},
            searchOption: [

            ],
        });
        const handleSearch = async () => {
            data.tableData = [];
            const res = await rechargeConfigList({
                size: mainTempRef.value.pageSize,
                current: mainTempRef.value.currentPage,
                ...mainTempRef.value.searchParams,
            });
            mainTempRef.value.setTotalValue(res && res.total);
            data.tableData = res.records || [];
        };
        const handleAddOwner = () => {
            data.currentData = {userType: 1};
            AddEditUserRef.value.handleToggle(true);
        };
        const handleAddWasher = () => {
            data.currentData = {userType: 2};
            AddEditUserRef.value.handleToggle(true);
        };

        const handleUpdateTable = () => {
            handleSearch();
        };
        provide("handleUpdateTable", handleUpdateTable);
        provide("handleSearch", handleSearch);

        onMounted(() => {
            handleSearch();
        });
        return {
            AddEditUserRef,
            handleAddWasher,
            handleAddOwner,
            mainTempRef,
            data,
            handleSearch,
        };
    },
};
</script>

<style scoped>
</style>
